import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import circleArrow from 'four-nets/icons/svg/icon_arrow-collapse.svg';

import { CatalogCategoryFragment } from './catalog-category.graphql';
import defaultStyles from './catalog-category.scss';

interface Props extends Partial<CatalogCategoryFragment> {
    styles: typeof defaultStyles;
    title: string;
    selected: boolean;
    hideNotSelected: boolean;
    onClick: () => void;
    mini: boolean;
    parentCategories: boolean;
}

interface State {
    initiallySelected: boolean;
}

class CatalogCategory extends React.Component<Props, State> {
    state = { initiallySelected: this.props.selected };

    render() {
        const { styles, edges, title, selected, hideNotSelected, onClick, mini, parentCategories = true } = this.props;

        const sortedEdges = [...(edges || [])].sort((a, b) => a?.node?.name?.localeCompare(b?.node?.name!) || -1);

        return (
            <div
                className={classnames(styles.panelGroup, {
                    [styles.collapsed]: !selected && parentCategories,
                    [styles.hiddenOnMobile]: !this.state.initiallySelected && hideNotSelected,
                })}
            >
                {parentCategories ? (
                    <h2 className={styles.heading}>
                        <button className={styles.button} onClick={onClick}>
                            <div className={styles.buttonContent}>
                                {title}
                                <div
                                    className={classnames({
                                        [styles.iconDisplay]: !mini,
                                        [styles.iconDisplayMini]: mini,
                                    })}
                                >
                                    <SVGIcon style={{ image: styles.image }} src={circleArrow} />
                                </div>
                            </div>
                        </button>
                    </h2>
                ) : null}
                {sortedEdges ? (
                    <ul
                        className={classnames(styles.list, {
                            [styles.hiddenLinksWrapper]: !selected && !mini && parentCategories,
                            [styles.hiddenLinksWrapperMini]: !selected && mini && parentCategories,
                            [styles.linksWrapperMini]: mini && parentCategories,
                            [styles.linksWrapper]: !mini,
                        })}
                        style={{
                            maxHeight: sortedEdges.length * 60 + 10,
                            transition: `all .5s ease-out`,
                        }}
                    >
                        {sortedEdges.map(edge => {
                            const { id, slug, vendorCount, name } = (edge && edge.node)!;
                            return (
                                <li key={id} className={styles.item}>
                                    {slug ? (
                                        <NavLink
                                            to={`/catalog/category/${slug}`}
                                            className={styles.link}
                                            activeClassName={styles.active}
                                        >
                                            {name}
                                        </NavLink>
                                    ) : null}
                                    {vendorCount ? <span className={styles.count}>({vendorCount})</span> : null}
                                </li>
                            );
                        })}
                    </ul>
                ) : null}
            </div>
        );
    }
}

export default Styled(defaultStyles)(CatalogCategory);
